/* eslint-disable react/react-in-jsx-scope */
import Modal from '@mui/material/Modal';
import { PopupPrintfAction, PopupPrintfProps } from 'components/popup-print/types';
import { TypePrint } from 'constants/AppEnums';
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Language } from 'shared/Language';
import Box from '@mui/material/Box';
import parse, {
    DOMNode,
    Element,
    HTMLReactParserOptions
} from 'html-react-parser';
import './styles.scss';
import { renderHTMLBillBG } from './BillBG';
import { renderHTMLBill } from './Bill';
import { renderHTMLBillInvoice } from './BillInvoice';
import { InfoHotelModel, OrderModel } from 'models/order';
import { fetchArea, fetchInfoHotel, fetchInfoPrintOrder, sendOrderSuccess } from 'service/orderService';
import axios from 'axios';
import { toast } from 'react-toastify';
import printService from './printService';
import printServiceReceipt from './printServiceReceipt';
// import printServiceReceipt from './printServiceReceipt';

const options: HTMLReactParserOptions = {
    replace: (domNode: DOMNode) => {
        if (
            domNode instanceof Element &&
            domNode.attribs &&
            domNode.attribs.class === 'remove'
        ) {
            return <></>;
        }
    }
};

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};

const PopupPrintOrder = forwardRef<PopupPrintfAction, PopupPrintfProps>(({ title }: PopupPrintfProps, ref) => {

    const [visible, setVisible] = useState<boolean>(false);
    const [type, setType] = useState<number>(0);
    const [data, setData] = useState<OrderModel>();
    const [dataOrder, setDataOrder] = useState<OrderModel>();
    const [context, setContext] = useState<any>();

    const [infoHotel, setInfoHotel] = useState<InfoHotelModel>();
    const componentRef = useRef();

    const showModal = (value, item) => {
        setVisible(true);
        setType(value);
        setData(item);
        getInfoHotel(item?.orderId);
    };

    const hideModal = () => {
        setVisible(false);
    };

    const onConfirm = async () => {
        switch (type) {
            case TypePrint.BILL:
                return printService(dataOrder);
            case TypePrint.BILL_MN:
                return printServiceReceipt(dataOrder, context);
            default:
                return '';
        }
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    const getInfoHotel = useCallback(async (id: string | number) => {
        const res = await fetchInfoPrintOrder(id);
        if (res.message === 'Success') {
            const _data = res.metadata[0] as any;
            setDataOrder(_data);
            setInfoHotel(_data?.hotelDetail);
            await loadImageAndPrint(_data?.img);
        }
    }, []);

    const renderHTML = () => {
        console.log('TypePrint.BILL_MN', data, infoHotel);

        switch (type) {
            case TypePrint.INVOICE:
                return renderHTMLBillInvoice(data, infoHotel);
            case TypePrint.BILL:
                return renderHTMLBill(dataOrder);
            case TypePrint.BILL_MN:
                return renderHTMLBillBG(dataOrder);
            default:
                return '';
        }
    };

    useImperativeHandle(ref, () => ({
        showModal,
        hideModal
    }));

    const loadImageAndPrint = async (image) => {
        try {
            const canvas = document.createElement("canvas");
            const _context = canvas.getContext("2d");

            const img = new Image();
            img.crossOrigin = "Anonymous"; // Cho phép load ảnh từ URL bên ngoài
            img.src = image ||
                "https://api.vietqr.io/image/970436-1041677509-6BKQEDo.jpg?accountName=CTCP QLKSDV MANDALA CN MUI NE&amount=130410&addInfo=CS231004 0012";

            img.onload = () => {
                // Đảm bảo kích thước đúng
                canvas.width = 250;
                canvas.height = 250;

                // Vẽ ảnh lên canvas
                _context.drawImage(img, 0, 0, 250, 250);

                // Lấy ImageData từ canvas
                setContext(_context);
            };

            img.onerror = () => {
                console.error("Không thể tải ảnh!");
            };
        } catch (error) {
            console.error("Lỗi khi load ảnh:", error);
        }
    };

    return (
        <Modal open={visible}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">

            <Box sx={style}>
                <div className='popup-print-order'>
                    <div className="popup-print-container">
                        {infoHotel && data && <div className="popup-print-top" ref={componentRef}>
                            <pre>
                                {parse(renderHTML(), options)}
                            </pre>
                        </div>}
                    </div>
                    <div className="button-contain">
                        <div onClick={hideModal} className={type !== TypePrint?.INVOICE ? "button-left" : "button-center"}>Close</div>
                        {type !== TypePrint?.INVOICE ? <div className="button-right" onClick={onConfirm} >{Language.common.print}</div> : null}
                    </div>
                </div>
            </Box>

        </Modal>
    );
});
export default PopupPrintOrder;
